module.exports = __webpack_public_path__ + "img/137.7daf1df6.jpg";